import { render } from "./IconAccessibility.vue?vue&type=template&id=4a86ada9"
import script from "./IconAccessibility.vue?vue&type=script&lang=js"
export * from "./IconAccessibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__